<router-outlet />
<ngx-spinner
size = "medium"
type = "square-jelly-box">
<p style="color: white" > Loading... </p></ngx-spinner>
<app-offline></app-offline>
